// EditTreatmentsModal.js
import React from "react";
import BasicModal from "../_widgets/Modal/BasicModal";
import { Col, Form, Row } from "react-bootstrap";
import Input from "../_widgets/Input/Input";
import { warn } from "../../Wrapper/toast/toast";
import {
  MAX_200_QTY_LIMIT_REACHED,
  MAX_30_CHARS,
  MAX_50_CHARS,
  MAX_QTY_LIMIT_REACHED,
} from "../../Constants/stringConstants";

const EditTreatmentsModal = ({
  modalShow,
  setModalShow,
  handleClose,
  addTreatmentData,
  addTreatment,
  editTreatment,
  buttonLoading,
  setAddTreatmentData,
}) => {
  return (
    <BasicModal
      show={modalShow}
      size="md"
      setModalShow={setModalShow}
      handleClose={handleClose}
      heading={`${addTreatmentData.action} Treatment`}
      footer
      button2Text="Save"
      button2Click={() =>
        addTreatmentData.action === "Add" ? addTreatment() : editTreatment(addTreatmentData.id)
      }
      loading={buttonLoading}
    >
      <div className="patients_ui">
        <Row>
          <Col xl={12}>
            <div className="white_card text-start">
              <Row className="mb-3">
                <Col lg={12}>
                  <Input
                    isRequired
                    placeholder="Enter Treatment Name"
                    type="text"
                    label="Name"
                    value={addTreatmentData.name}
                    onChange={(e) => {
                      if (e.target.value.length <= 30) {
                        setAddTreatmentData({
                          ...addTreatmentData,
                          name: e.target.value,
                        });
                      } else {
                        warn(MAX_30_CHARS);
                      }
                    }}
                  />
                </Col>
                <Col lg={12}>
                  <Input
                    isRequired
                    placeholder="Enter Default Qty"
                    inputType="number"
                    label="Default Qty"
                    value={addTreatmentData.default_qty}
                    onChange={(e) => {
                      const val = e.target.value;

                      if (val === "") {
                        setAddTreatmentData({
                          ...addTreatmentData,
                          default_qty: "",
                        }); // Allow clearing
                      } else if (!isNaN(val) && parseInt(val) <= 200) {
                        setAddTreatmentData({
                          ...addTreatmentData,
                          default_qty: parseInt(val),
                        });
                      } else if (!isNaN(val)) {
                        warn(MAX_200_QTY_LIMIT_REACHED);
                      }
                    }}
                  />
                </Col>

                <Col lg={12}>
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Enter Description Here"
                    rows={4}
                    value={addTreatmentData.description}
                    onChange={(e) => {
                      if (e.target.value.length <= 50) {
                        setAddTreatmentData({
                          ...addTreatmentData,
                          description: e.target.value,
                        });
                      } else {
                        warn(MAX_50_CHARS);
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </BasicModal>
  );
};

export default EditTreatmentsModal;
